import { render, staticRenderFns } from "./LoggedUser.vue?vue&type=template&id=49e09226&"
import script from "./LoggedUser.vue?vue&type=script&lang=js&"
export * from "./LoggedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports